import { IInitAction } from './init'
import { IGroupDetailed } from './group'

// Action types
export enum types {
  GET_GROUPS_DETAILED__STARTED = 'GET_GROUPS_DETAILED__STARTED',
  GET_GROUPS_DETAILED__SUCCESS = 'GET_GROUPS_DETAILED__SUCCESS',
  GET_GROUPS_DETAILED__FAILURE = 'GET_GROUPS_DETAILED__FAILURE',
  UPDATE_GROUPS_DETAILED = 'UPDATE_GROUPS_DETAILED',
}

export interface IGetGroupsDetailedAction {
  type: types.GET_GROUPS_DETAILED__STARTED
}

export interface IGetGroupsDetailedSuccessAction {
  type: types.GET_GROUPS_DETAILED__SUCCESS
  list: IGroupDetailed[]
}

export interface IFailureAction {
  type: types.GET_GROUPS_DETAILED__FAILURE
  message: string
}

export interface IUpdateGroupsDetailedAction {
  type: types.UPDATE_GROUPS_DETAILED
  list: IGroupDetailed[]
}

export type GroupsActionsType =
  | IGetGroupsDetailedAction
  | IGetGroupsDetailedSuccessAction
  | IUpdateGroupsDetailedAction
  | IFailureAction
  | IInitAction

// Reducer types
export interface IGroupsDetailed {
  isLoading: boolean
  isLoaded: boolean
  list: IGroupDetailed[]
}
